import Quill from 'quill'

const LinkBlot = Quill.import('formats/link')
const ImageBlot = Quill.import('formats/image')

class ImageEmbed extends ImageBlot {
	static create (data) {
		let node = super.create(data)
		node.classList.add('embeddedimage')
		return node
	}

	static sanitize (url) {
		return LinkBlot.sanitize(url, ['http', 'https', 'data', 'blob']) ? url : '//:0'
	}
}

export default ImageEmbed
